import { ProductFieldDto } from "../../autogen/bff-api";
import { ProductField } from "../types";

/**
 * Narrow a webapp `ProductField` into the BFF's discriminated-union `ProductFieldDto`.
 * The webapp uses `"Quantity"` internally to type unit-price fields; the API surface
 * only accepts `"Text"`, `"Number"`, and `"Boolean"`, so quantity fields must be filtered
 * before reaching this helper. Throws if one slips through — catches consumer bugs at
 * the serialization boundary rather than corrupting the wire shape.
 */
export const toProductFieldDto = (field: ProductField): ProductFieldDto => {
  if (field.type === "Quantity") {
    throw new Error(`ProductField "${field.name}" has type "Quantity" which is not a valid API type`);
  }
  return {
    id: field.id,
    name: field.name,
    type: field.type,
    populatedBy: field.populatedBy,
    isRequired: field.isRequired,
    value: field.value ?? undefined,
  } as ProductFieldDto;
};
